// nodes/filterNode.js
import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";

export const FilterNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.filter} />
);
